import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError, NavigationCancel } from '@angular/router';
import { filter, switchMap, take, mergeMap, map } from 'rxjs/operators';
import { LoadingBar } from './loading-bar';
import { merge, Observable, interval, of, Subscription } from 'rxjs';

@Injectable()
export class RouteLoadingBar implements OnDestroy {
    private readonly loadingBarDelay = 1000;
    private routeSubscription: Subscription;

    constructor(
        private readonly router: Router,
        private readonly loadingBar: LoadingBar
    ) { }

    public ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }

    public setupRouteLoadingBar() {
        this.routeSubscription = merge(
            this.showLoadingBar(),
            this.hideLoadingBar()
        ).pipe(
            switchMap(x => x)
        ).subscribe();
    }

    private showLoadingBar() {
        const showing$ = new Observable<void>(subscribe => {
            this.loadingBar.show();

            subscribe.next();

            return () => {
                this.loadingBar.hide();
            };
        });

        const delayedLoadingBar$ = interval(this.loadingBarDelay)
            .pipe(
                take(1),
                mergeMap(() => showing$)
            );

        return this.router.events.pipe(
            filter(event => event instanceof NavigationStart),
            map(() => delayedLoadingBar$)
        );
    }

    private hideLoadingBar() {
        return this.router.events.pipe(
            filter(event => event instanceof NavigationEnd
                || event instanceof NavigationError
                || event instanceof NavigationCancel),
            map(() => of<void>())
        );
    }
}